import $ from 'jquery';
import Popper from 'popper.js';

export default class TextDescriptions {
  init() {
    const blocks = $('.site-main .wp-block-wrapper');
    const definitions = window.textDescriptions;
    const popoverFadeTime = 300;

    if (typeof definitions === 'undefined' || definitions.length === 0) {
      return;
    }

    // Create regex from definitions
    const regexes = definitions.reduce((acc, cur) => {
      let options = 'g';
      if (cur.ignore_case) {
        options += 'i';
      }
      acc.push(RegExp(cur.regex, options));
      return acc;
    }, []);

    // Find text matches in html
    blocks.find('p, ul, ol').each((i, elm) => {
      const self = $(elm);
      const oldHtml = self.html();

      definitions.map((def, index) => {
        const regex = regexes[index];
        if (regex.test(oldHtml) === true) {
          self.html(oldHtml.replace(regex, match => {
            return `<span data-text-decoration="${def.id}" class="js-text-description">${match}</span>`;
          }));
        }
      });
    });

    // Create tooltips
    definitions.map(def => {
      const popover = $('<div />')
        .attr('id', `text-decoration-${def.id}`)
        .addClass('text-description__content')
        .addClass('popper')
        .html(def.content);

      $('body').append(popover);
      popover.hide();
    });

    // Toggle popovers
    $('.js-text-description').each((i, elm) => {
      const self = $(elm);
      const popperId = self.data('text-decoration');
      const popover = $(`#text-decoration-${popperId}`);

      const initPopper = elm => {
        if (!$(elm).data('popper')) {
          const popper = new Popper(elm, popover, {
            placement: 'top',
            removeOnDestroy: true,
          });
          $(elm).data('popper', popper);
        }
        return $(elm).data('popper');
      };

      self.on('click touchend', evn => {
        const elm = evn.target;

        const popper = initPopper(elm);

        if ($(elm).is($(popper))) {
          return;
        }

        evn.preventDefault();

        if ($(popper.popper).is(':visible')) {
          $(popper.popper).fadeOut(popoverFadeTime);
        } else {
          popper.scheduleUpdate();
          $(popper.popper).fadeIn(popoverFadeTime);
        }

        evn.stopPropagation();
      });

      self.on('mouseover', evn => {
        const elm = evn.target;

        const popper = initPopper(elm);

        popper.scheduleUpdate();
        $(popper.popper).fadeIn(popoverFadeTime);
      });

      self.on('mouseout', evn => {
        const elm = evn.target;

        const popper = initPopper(elm);

        $(popper.popper).fadeOut(popoverFadeTime);
      });

      self.addClass('text-description--active');
    });
  }
}
